import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresListaComponent {
  constructor($filter, FanProyectoColaboradoresService) {
    this.$filter = $filter
    this.idProyecto = undefined
    this.FanProyectoColaboradoresService = FanProyectoColaboradoresService
    this.filterBy = $filter('filter')
    this.orderBy = $filter('orderBy')
    this.exportando = false
    this.idse = false
    this.filtro = {
      texto: '',
      departamento: '',
      puesto: '',
      status: '',
    }
  }

  $onInit() {
    this.promise = this.FanProyectoColaboradoresService.get(this.idProyecto)
      .then((response) => {
        this.data = this.orderBy(response.data, ['departamento', 'estatus', 'colaborador'])
          .map((item) => {
            item.activo = item.estatus === 'Activo'

            return item
          })

        this.activos = this.data.filter((item) => item.estatus === 'Activo').length

        this.catalogos = {
          Status: ['Activo', 'Inactivo'],
          Departamentos: this.data.reduce((prev, next) => prev.concat(prev.indexOf(next.departamento) < 0 ? [next.departamento] : []), []),
          Puestos: this.data.reduce((prev, next) => prev.concat(prev.indexOf(next.puesto) < 0 ? [next.puesto] : []), []),
        }

        this.filtrar()
      })
  }

  descargarIDSE () {
    this.idse = true
  }

  filtrar() {
    this.resultados = this.filterBy(this.data, {
      $: this.filtro.texto,
      departamento: this.filtro.departamento,
      puesto: this.filtro.puesto,
    })

    if (this.filtro.status) {
      this.resultados = this.resultados.filter((item) => item.estatus === this.filtro.status)
    }

    this.ocultos = this.data.length - this.resultados.length
  }
}

module.component('fanProyectoColaboradoresLista', {
  controller: FanProyectoColaboradoresListaComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    permisos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/lista/component.js